import { render, staticRenderFns } from "./ExternalBrandManage.vue?vue&type=template&id=096102e3&scoped=true&"
import script from "./ExternalBrandManage.vue?vue&type=script&lang=js&"
export * from "./ExternalBrandManage.vue?vue&type=script&lang=js&"
import style0 from "./ExternalBrandManage.vue?vue&type=style&index=0&id=096102e3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096102e3",
  null
  
)

export default component.exports